<template>
    <MainContentSearchable title="Listado de campos personalizados para la lista de abonados" id="fields" v-model="filters" :meta="loading ? {} : fields.meta" @updated="debouncedGetFields">
        <template v-slot:header>
            <h3 class="card-title pb-3">Listado de campos personalizados para la lista de abonados</h3>
            <div class="card-tools">
                <Button @click="showModal('add-fields')">Añadir campo</Button>
                <AddCampo :key="reload" :filters="{ lista_id: lista_id }" @close="closeModal" @vincularFields="vincularFields"/>
            </div>
        </template>

        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="fields" class="table-responsive has-options">
                    <b-table hover :items="fields.data" :fields="campos" :busy="loading">
                        <template #cell(type)="{ item }">
                            <section v-if="(item.type === 'select' || item.type === 'multiselect') && item.options.length > 0" :id="'select-options-tooltip-' + item.id">
                                <i class="fas fa-info-circle"></i>
                                {{ item.type }}
                                <b-tooltip :target="'select-options-tooltip-' + item.id" triggers="hover">
                                    <span v-for="(field, index) in item.options" :key="index" class="d-inline-block mr-1">
                                        {{ field.name }}
                                        <span v-if="index !== item.options.length - 1">, </span>
                                    </span>
                                </b-tooltip>
                            </section>
                            <section v-else>
                                {{ item.type }}
                            </section>
                        </template>
                        <template #cell(required)="{ item }">
                            <span v-if="item.required" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(opciones)="{ item }">
                            <OpcionesDropdownComponent v-bind:options="[
                                { type: 'action', action:() => showModal('desvincular-campo-' + item.id), label: 'Borrar' },
                            ]"
                            />
                            <BorrarModalComponent
                                :name="'desvincular-campo-' + item.id"
                                title="Desvincular campo"
                                confirmButton="¿Está segur@ de desvincular el campo de los abonos?"
                                @close="() => closeModal('desvincular-campo-' + item.id, false)"
                                @confirm="() => desvincularField(item.id)"
                            />
                        </template>
                    </b-table>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import AddCampo from '@/components/backend/common/AddCampo.vue';
    import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        props: ['lista_id'],
        data() {
            return {
                loading: false,
                fields: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                campos: [
                    { key: "name", label: "Nombre", class: 'text-center' },
                    { key: "type", label: "Tipo", class: 'text-center' },
                    { key: "required", label: "Requerido", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
                reload: 1
            }
        },
        methods: {
            getFields() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    lista_id: this.lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.forms.campos-personalizados'), params).then(res => {
                    this.fields = res.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            vincularFields(fieldsIds) {
                this.loading = true;

                const params = {
                    filters : {},
                    fieldsIds: fieldsIds,
                    lista_id: this.lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.forms.campos-personalizados.add'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.closeModal('add-fields', true);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.closeModal('add-fields', false);
                }).finally(() => {
                    this.loading = false;
                });
            },
            desvincularField(field_id) {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    lista_id: this.lista_id,
                    field_id: field_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.forms.campos-personalizados.delete'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.closeModal('desvincular-campo-' + field_id, true)
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.closeModal('desvincular-campo-' + field_id, false)
                }).finally(() => {
                    this.loading = false;
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.$modal.hide(modal);
                if (creado) {
                    this.reload += 1;
                    this.getFields();
                }
            }
        },
        created() {
            this.getFields();
            this.debouncedGetFields = _.debounce(this.getFields, 500)
        },
        components: {
            MainContentSearchable, OpcionesDropdownComponent, BorrarModalComponent, AddCampo
        }
    }
</script>